import { render, staticRenderFns } from "./goodsItr.vue?vue&type=template&id=429f15c2&scoped=true&"
import script from "./goodsItr.vue?vue&type=script&lang=js&"
export * from "./goodsItr.vue?vue&type=script&lang=js&"
import style0 from "./goodsItr.vue?vue&type=style&index=0&id=429f15c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "429f15c2",
  null
  
)

export default component.exports